/**
 * Получение гет параметра из урла.
 *
 * @param  {string} key
 * @returns {?string}
 */
export const getParamFromUrl = (key) => {
  const sPageURL = decodeURIComponent(window.location.search.substring(1));
  const sURLVariables = sPageURL.split('&');
  let sParameterName;
  let i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === key) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }

  return undefined;
};
